export const defaultPageConfig = {
  small: false,
  background: true,
  pageSize: 20,
  layout: "prev, pager, next,total, jumper, sizes",
  // layout: "prev, pager, next,total, jumper",
  pageSizes: [20, 50, 100]
};
